import useEntityTranslations from "../../../../../../hooks/useEntityTranslations";
import TextFormView from "./TextFormView";

function TextForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
}) {
  const translationsController = useEntityTranslations(
    selectedLabelItem.translations || [],
    onTranslationsChange
  );

  /**
   * This method will handle the translations change event.
   * @param {array} translations
   */
  function onTranslationsChange(translations) {
    setPrinterData((prevData) => {
      const newLabelItems = [...prevData.label_items];
      newLabelItems[selectedLabelItemIndex] = {
        ...newLabelItems[selectedLabelItemIndex],
        translations: translations,
      };
      return {
        ...prevData,
        label_items: newLabelItems,
      };
    });
  }

  return (
    <TextFormView
      setPrinterData={setPrinterData}
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      translationsController={translationsController}
      submitError={submitError}
    />
  );
}

export default TextForm;
